

<form class="flex-1 flex-row gap-standard" [formGroup]="(mainFormGroupSubject | async) || mainFormGroupSubject.value">
    
    <ss-autocomplete-form-control class="flex-2" #autocompleteRef dataField="email" formControlName="email"></ss-autocomplete-form-control>
    <ss-text-form-control class="flex-1" dataField="firstName" formControlName="firstName"></ss-text-form-control>
    <ss-text-form-control class="flex-1" dataField="lastName" formControlName="lastName"></ss-text-form-control>    
    <ss-text-form-control class="flex-1" dataField="mobile" formControlName="mobile"></ss-text-form-control>

</form>

<div class="form-field-height flex-row gap-small flex--align-center">
    <button type="button" [disabled]="configDisabledObs | async" mat-icon-button color="primary" type="button" (click)="toggleExpanded()">
        <mat-icon class="arrow-icon">settings</mat-icon>
    </button>
    
    <ng-container *ngTemplateOutlet="suffixTemplateSubject | async"></ng-container>
</div>

